import { type Product } from '@/infra/services/catalog/product/get-product-info/model';
import { type Seller } from '@/infra/services/catalog/product/get-sellers/model';
import type { Product as WishlistTrackerProduct } from '@/infra/tracking/tracker/wishlist/tracker';

interface MapToWishlistProductProps {
  product: Product;
  currentSeller: Seller;
}

export default function mapToWishlistProduct(
  props: MapToWishlistProductProps
): WishlistTrackerProduct {
  const { currentSeller, product } = props;

  const { _id: id, short_name, url, brand, unit } = product;
  const {
    pricing: { price, discount },
  } = currentSeller;

  return {
    id: id,
    shortName: short_name,
    categoryTree: '',
    price: {
      from: price.from,
      to: price.to,
      discount: {
        percentage: discount.percentage,
        type: discount.type,
        labels: { paymentMethod: String(discount.paymentMethods) },
        featureInstallmentDiscount: false,
      },
    },
    unit: unit,
    url: url,
    brand: brand,
    picture: '',
    meta: {
      hasService: false,
      inWishlist: false,
      isOutlet: false,
      isSoldOut: false,
    },
  };
}
